import axios from '../../utilities/axios';
import { ofType } from 'redux-observable';
import { of, merge } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';
import { failureMessage } from '../Notifications/notificationsSlice';

import { get } from '../../utilities/configUtility';

import {
	getSiteConfig,
	getSiteConfigCompleted,
	getSiteConfigFailed
} from './siteConfigSlice';

export const getProjectsEpic = (action$) =>
	action$.pipe(
		ofType(getSiteConfig.type),
		mergeMap(async () => {
			try {
				const response = await axios.get(`${get('cdn')}/config`);

				// @TODO: If the config comes back, decrypt it before it hits the reducer.

				return response.data;
			} catch (e) {
				return {
					error: e.message
				};
			}
		}),
		switchMap((res) => {
			return [getSiteConfigCompleted(res)];
		}),
		catchError((error, source) => {
			return merge(
				of(getSiteConfigFailed(error.message), failureMessage(error.message)),
				source
			);
		})
	);

export default [getProjectsEpic];
